import styles from '../index.module.css'

const NoVideoBox = () => {

    return (
        <div className={styles["container"]}>
            <div style={{ textAlign: 'center' }}>
                <div className={styles["icon"]}>🎥</div>
                <h3>No Playback Loaded</h3>
                <span>Select a recording from the list below to start playback</span>
            </div>
        </div>
    )
};

export default NoVideoBox